import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  AgentName,
  AGENTS_QUERY_OPTIONS,
  GET_AGENTS_QUERY_KEY,
} from '@/constant/agents';
import { agentsApi } from '@/services/agents';
import { Agent } from '@/types/agents';

export function useAgents(agentName: AgentName): UseQueryResult<Agent>;
export function useAgents(): UseQueryResult<Agent[]>;
export function useAgents(agentName?: AgentName) {
  const agentsQuery = useQuery({
    queryKey: [GET_AGENTS_QUERY_KEY],
    queryFn: () => agentsApi.getAgents(),
    select: data =>
      agentName ? data?.find(agent => agent.name === agentName) : data,
    ...AGENTS_QUERY_OPTIONS,
  });

  return agentsQuery;
}

export function useAgentPromptCommands(agentId: Agent['id'] | undefined) {
  const agentsQuery = useQuery({
    queryKey: [GET_AGENTS_QUERY_KEY, agentId],
    queryFn: () => agentsApi.getAgentPromptCommands(agentId!),
    ...AGENTS_QUERY_OPTIONS,
    select: data => {
      const items = data?.items || [];
      const legacy = data?.legacy || [];

      return {
        items,
        allItems: [...items, ...legacy],
      };
    },
    enabled: !!agentId,
  });

  return agentsQuery;
}
